const GET = 'GET';

const ajax = (method, uri) => {
  return new Promise((resolve, reject) => {
    const client = new XMLHttpRequest();
    client.open(method, uri);

    client.timeout = 60000;

    client.onload = () => {
      if (client.status >= 200 && client.status < 300) {
        resolve(client.response);
      } else {
        reject(JSON.parse(client.response));
      }
    };

    client.ontimeout = () => reject(client.statusText);
    client.onerror = () => reject(client.statusText);
    client.send();
  });
};

const fetch = {
  /**
   * Get requst from a resource.
   *
   * @param {Uri} uri
   * @returns {Promise}
   */
  get(uri) {
    return ajax(GET, uri.toString());
  },
  getJson: async (uri) => {
    const response = await ajax(GET, uri.toString());
    return JSON.parse(response);
  },
  getJsonByProxy: async (uri, baseUrl) => {
    const url = `${baseUrl}/api/proxy?url=${encodeURIComponent(uri.toString())}`;
    const response = await ajax(GET, url);
    return JSON.parse(response);
  },
};

export default fetch;